import {
    AfterViewInit,
    Directive,
    ElementRef,
    Host,
    OnDestroy,
    Optional,
    Self,
} from '@angular/core';
import { SelectComponent } from '@cmps/ng-select';

@Directive({
    selector: '[forceDropdownPosition]',
})
export class ForceDropdownPositionDirective
    implements AfterViewInit, OnDestroy
{
    constructor(
        @Host()
        @Self()
        @Optional()
        public hostComponent: SelectComponent,
        public el: ElementRef, // public cd: ChangeDetectorRef,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngAfterViewInit() {
        this.hostComponent.opened.subscribe((t) => {
            // eslint-disable-next-line @typescript-eslint/dot-notation
            // if (!this.cd['destroyed']) {
            //     this.cd.detectChanges();
            // }

            setTimeout(() => {
                const dd = this.hostComponent.dropdown;
                if (dd) {
                    const my = this.el.nativeElement.getBoundingClientRect();
                    dd.isBelow = true;
                    dd.top = my.height;
                }
                // eslint-disable-next-line @typescript-eslint/dot-notation
                // if (!this.cd['destroyed']) {
                //     this.cd.detectChanges();
                // }
            });
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        if (this.hostComponent.opened) {
            this.hostComponent.opened.unsubscribe();
        }
    }
}
